import { render, staticRenderFns } from "./ProfileImageUploader.vue?vue&type=template&id=154efafd&scoped=true"
import script from "./ProfileImageUploader.vue?vue&type=script&lang=js"
export * from "./ProfileImageUploader.vue?vue&type=script&lang=js"
import style0 from "./ProfileImageUploader.vue?vue&type=style&index=0&id=154efafd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154efafd",
  null
  
)

export default component.exports